import { MeasureFactory } from './measureFactory';

import type {
  MeasureEntity,
  MeasurePropsPub,
  MeasurePropsPvt,
} from './measureEntity';
import type { MeasureIRepository } from './measureIRepository';
import type { EntityDataPubType } from '@/infra/appsync';
import type { MeasureJsonPub, MeasureJsonPvt } from '@/types/domain/measure/entities/measureEntity';

import { AppsyncRepository } from '@/domain/appsyncRepository';
import {
  EntityName,
} from '@/infra/appsync';

export class MeasureRepository extends AppsyncRepository<
  MeasureEntity,
  MeasurePropsPvt,
  MeasureJsonPvt,
  MeasurePropsPub,
  MeasureJsonPub
> implements MeasureIRepository {
  private factory = new MeasureFactory();

  protected get entityName(): EntityName {
    const name: EntityName = EntityName.WagakoAppMeasureMeasureEntity;
    return name;
  }

  /**
   * DBデータをEntityに変換
   * @param props DBデータ
   * @returns Entity
   */
  protected createFromEntityType = (
    props: EntityDataPubType,
  ) => this.factory.createFromEntityType(props);
}
